import currency from 'currency.js'

export const RMB = value => currency(value)

const W = 10000

class TicketSplit {
  static MAXLIMIT = 10 * W
  // dataSource 源开票数据
  // limitKey 根据该字段与限额比较
  // conditionKeys 比较条件的字段 所有字段对应的值相等
  constructor (dataSource, limitKey, conditionKeys) {
    this.dataSource = dataSource
    this.limitKey = limitKey
    this.conditionKeys = conditionKeys
  }

  // 拆票
  transformation () {
    if (this._getTotal > TicketSplit.MAXLIMIT) {
      return this.transformationMoreThanMaxLimit()
    } else {
      return this.transformationLessThanMaxLimit()
    }
  }

  // 超过上限
  transformationMoreThanMaxLimit () {
    const result = []
    for (const key in this._mapDataSource) {
      const elements = this._mapDataSource[key]
      // 计算 条件相同情况下 所有明细金额和
      const total = elements.reduce((total, current) => {
        return RMB(total).add(current[this.limitKey])
      }, 0).value
      const maxlimit = this.maxLimit(elements[0].tax_rate)
      // 金额和 大于 上限 需要 拆分多张票
      if (total > maxlimit) {
        // 需要拆分金额上限的票数
        const splitCount = total / maxlimit
        result.push(...[
          ...this._copyElement(elements[0], splitCount, maxlimit)
            .map(item => [item]),
        ])
        // splitCount 是个小数的时候，把小数部分转化为一个票
        if (total % maxlimit !== 0) {
          result.push([{
            ...elements[0],
            // 这张票的金额
            [this.limitKey]: RMB(total).subtract(RMB(parseInt(splitCount)).multiply(maxlimit)).value
          }])
        }
      } else {
        // 否则单独为一张票 需要合并
        result.push([{
          ...this._mapDataSource[key][0],
          [this.limitKey]: this._mapDataSource[key].reduce((total, current) => {
            return RMB(total).add(current[this.limitKey])
          }, 0).value
        }])
      }
    }
    return result
  }

  // copy total 个 source
  // 需要修改 limitKey 为 _maxLimit
  _copyElement (source, total, maxlimit) {
    const results = []
    for (let i = 0; i < parseInt(total); i++) {
      results.push({
        ...source,
        [this.limitKey]: maxlimit
      })
    }
    return results
  }

  // 未超过上限
  transformationLessThanMaxLimit () {
    const result = [[]]
    for (const key in this._mapDataSource) {
      result[0].push({
        ...this._mapDataSource[key][0],
        [this.limitKey]: this._mapDataSource[key].reduce((total, current) => {
          return RMB(total).add(current[this.limitKey])
        }, 0).value
      })
    }
    return result
  }

  // 将源数据 转化为 map 对象 key 为 初始化参数中 conditionKeys 字段取到源数据的 值
  get _mapDataSource () {
    return this.dataSource.reduce((total, current) => {
      const key = this.conditionKeys.map(key => {
        return current[key] || key
      }).join('-')

      if (total[key]) {
        total[key].push(current)
      } else {
        total[key] = [current]
      }
      return total
    }, {})
  }

  // 每张票的 最大限额
  maxLimit (taxRate) {
    if (this.limitKey === 'total') {
      return TicketSplit.MAXLIMIT
    } else {
      return RMB(TicketSplit.MAXLIMIT).divide(RMB(1).add(taxRate * 0.01)).value
    }
  }

  // 最大限额
  // get _maxLimit () {
  //   if (this.limitKey === 'total') {
  //     return TicketSplit.MAXLIMIT
  //   } else {
  //     return RMB(TicketSplit.MAXLIMIT).divide(RMB(1).add(this.taxRate)).value
  //   }
  // }

  // 源数据金额和
  get _getTotal () {
    return this.dataSource.reduce((total, current) => {
      return RMB(total).add(current.total)
    }, 0).value
  }
}

export default TicketSplit



// WEBPACK FOOTER //
// ./src/views/invoice-apply/components/ticket-split/index.js